import React from 'react'
import businessData from 'sprockets_react/data/business/data'

class PricingFooter extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      contractPrice: null,
      additionalPaymentContractUpgrade: null
    }

    this.processContract = this.processContract.bind(this)
    this.handleUpgradePriceChange = this.handleUpgradePriceChange.bind(this)
    this.handleContractPriceChange = this.handleContractPriceChange.bind(this)
    this.processMembership = this.processMembership.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        contractPrice: this.props.contractPrice,
        additionalPaymentContractUpgrade: this.props.additionalPaymentContractUpgrade
      })
    }
  }

  cancelAllChanges() {
    document.location.href = '/products/membership'
  }

  showCCForm() {
    let $ccContainer = $('#memberships').find('.credit-card')

    $ccContainer.rmHidden().velocity('transition.slideDownIn')
    SS.appFn.scrollTo($ccContainer)
  }

  processMembership() {
    let serialized_job_filter_data = businessData.serialized_job_filter_data
    let serialized_prices = '&'.concat($('#edit-membership-form').serialize())
    let data = serialized_job_filter_data.concat(serialized_prices)
    let $button = $('.js-show-cc-form')
    let url = '/products/membership'

    $button.addClass('disabled')
    $button.text('Processing request...')
    $button.css('background-color', '#1ec659')

    $('#save-banner').addClass('slide-hide')
    $('.loading-overlay').rmHidden()

    $.ajax({
      url: url,
      type: 'POST',
      data: data
    }).done(function(data) {
      window.location.href = "/products/membership/edit" + "?show_banner=true"
    }).fail(function(jqXHR, textStatus) {
      document.location.href = '/500'
    })
  }

  processContract() {
    let serialized_job_filter_data = businessData.serialized_job_filter_data
    let serialized_prices = '&'.concat($('#edit-membership-form').serialize())
    let serialized_contract_id = `&related_contract_id=${this.props.relatedContractId}`
    let data = serialized_job_filter_data.concat(serialized_prices).concat(serialized_contract_id)
    let $button = $('.js-show-cc-form')
    let contractData = data.concat(`&amount=${this.state.contractPrice}&_method=POST&additional_price=${this.state.additionalPaymentContractUpgrade}`)

    $button.addClass('disabled')
    $button.text('Processing request...')
    $button.css('background-color', '#1ec659')

    $('#save-banner').addClass('slide-hide')
    $('.loading-overlay').rmHidden()

    $.ajax({
      url: '/products/business_contracts/',
      type: 'POST',
      dataType: 'json',
      data: contractData
    }).done(function(data) {
      if (data.business_contract_id) {
        window.location.href = `/products/business_contracts/${data.business_contract_id}`
      } else {
        window.location.href = "/products/membership/edit" + "?show_banner=true"
      }
    }).fail(function(jqXHR, textStatus) {
      document.location.href = '/500'
    })
  }

  handleUpgradePriceChange(event) {
    this.setState({ additionalPaymentContractUpgrade: event.currentTarget.value })
  }

  handleContractPriceChange(event) {
    this.setState({ contractPrice: event.currentTarget.value })
  }

  renderEditableUpgradeCosts() {
    return(
      <div>
        Costs $
        <input
          id='custom-pay-now-price'
          className='ml5 mr5 mb10'
          value={this.state.additionalPaymentContractUpgrade}
          onChange={this.handleUpgradePriceChange}>
        </input>
        today, and then
        <br />
        $
        <input
          id='custom-contract-price'
          className='ml5 mr5'
          value={this.state.contractPrice}
          onChange={this.handleContractPriceChange}>
        </input>
        {this.props.recurrence} immediately
      </div>
    )
  }

  render() {
    let recurrenceLabel = this.props.recurrence === 'monthly' ? 'month' : 'year'

    return (
      <div className="container hidden" id="pricing-footer">
        <div className="row">
          <div className="col-xs-12">
            <div className="row card card-flat bg-white card-pad-md mb24">
              <div className="font-16 bold pb16">
                You've edited your membership settings
              </div>
              <div className="mt20">
                <table className="table border">
                  <thead>
                    <tr>
                      <th className="pl20">CURRENT SETTINGS</th>
                      <th></th>
                      <th></th>
                      <th>NEW SETTINGS</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="text-copy-1 pl20">Avg leads<br/>/month</td>
                      <td className="font-16 bold">{this.props.currentAvgLeads}</td>
                      <td className="ficon-arrow-right-shaft"></td>
                      <td className="text-copy-1 pl20">Avg leads<br/>/month</td>
                      <td className="font-16 bold pr20">{this.props.newAvgLeads}</td>
                    </tr>
                    {
                      this.props.recurrence !== 'monthly' &&
                      <tr>
                        <td className="text-copy-1 pl20">Cost<br/>/{this.props.recurrence}</td>
                        <td className="font-16 bold">${this.props.currentBillingAmount}</td>
                        <td className="ficon-arrow-right-shaft"></td>
                        <td className="text-copy-1 pl20">Cost<br/>/{this.props.recurrence}</td>
                        <td className="font-16 bold pr20">${this.props.newBillingAmount}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
              {
                (!this.props.hasSignedContract && !this.props.hasActiveSignedContract) &&
                <div className="col-md-6 col-xs-12 pb24">
                  {
                    this.props.newBillingAmount < this.props.currentBillingAmount &&
                    <div>
                      <button onClick={this.processMembership} className="btn apply-monthly-btn btn-block btn-clear js-show-cc-form radius-6 mb10" style={{'whiteSpace': 'normal', 'minHeight': '65px'}}>
                        {
                          this.props.recurrence === "monthly" ?
                          <span>Apply New Settings and stay on<br/>month-to-month Membership</span>
                          :
                          <span>Apply new settings (Free)</span>
                        }
                      </button>
                      Costs <b>$0 today</b> and then <b>${this.props.newBillingAmount}/{recurrenceLabel}</b> starting {moment(this.props.billingDate).format('DD MMMM YYYY')}
                    </div>
                  }
                  {
                    this.props.newBillingAmount > this.props.currentBillingAmount &&
                    <div>
                      <button onClick={this.showCCForm} className="btn apply-monthly-btn btn-block btn-clear js-show-cc-form radius-6 mb10" style={{'whiteSpace': 'normal', 'minHeight': '65px'}}>
                        {
                          this.props.recurrence === "monthly" ?
                          <span>Apply New Settings and stay on<br/>month-to-month Membership</span>
                          :
                          <span>Pay ${this.props.additionalPayment} to apply new settings</span>
                        }
                      </button>
                      Costs <b>${this.props.additionalPayment} today</b> and then <b>${this.props.newBillingAmount}/{recurrenceLabel}</b> starting {moment(this.props.billingDate).format('DD MMMM YYYY')}
                    </div>
                  }
                  {
                    this.props.newBillingAmount === this.props.currentBillingAmount &&
                    <div>
                      <button onClick={this.processMembership} className="btn apply-monthly-btn btn-block btn-clear js-show-cc-form radius-6 mb10" style={{'whiteSpace': 'normal', 'minHeight': '65px'}}>
                        {
                          this.props.recurrence === "monthly" ?
                          <span>Apply New Settings and stay on<br/>month-to-month Membership</span>
                          :
                          <span>Apply new settings (Free)</span>
                        }
                      </button>
                      Costs <b>$0</b>
                    </div>
                  }
                </div>
              }
              {
                (this.props.recurrence === 'monthly' && (this.props.contractPrice < this.props.newBillingAmount) && this.props.billingDateValid && !this.props.exclusiveLeadOnlyContract) &&
                <div className="col-md-6 col-xs-12 pb24">
                  {
                    this.props.contractPrice < this.props.currentBillingAmount &&
                    <div>
                      <button className="btn apply-contract-btn btn-block btn-clear radius-6 mb10" style={{'whiteSpace': 'normal', 'minHeight': '65px'}} onClick={this.processContract} disabled={(this.props.processingContract === true) ? 'disabled' : false}>Apply New Settings on a 12 month contract</button>
                      Costs <b>$0 today</b> and then <b>${this.props.contractPrice}/{recurrenceLabel}</b> starting {moment(this.props.billingDate).format('DD MMMM YYYY')}
                    </div>
                  }
                  {
                    this.props.contractPrice > this.props.currentBillingAmount &&
                    <div>
                      <button className="btn apply-contract-btn btn-block btn-clear radius-6 mb10" style={{'whiteSpace': 'normal', 'minHeight': '65px'}} onClick={this.processContract} disabled={(this.props.processingContract === true) ? 'disabled' : false}>Apply New Settings on a 12 month contract</button>
                      Costs <b>${this.props.additionalPaymentContract} today</b> and then <b>${this.props.contractPrice}/{recurrenceLabel}</b> starting {moment(this.props.billingDate).format('DD MMMM YYYY')}
                    </div>
                  }
                  {
                    this.props.contractPrice === this.props.currentBillingAmount &&
                    <div>
                      <button className="btn apply-contract-btn btn-block btn-clear radius-6 mb10" style={{'whiteSpace': 'normal', 'minHeight': '65px'}} onClick={this.processContract} disabled={(this.props.processingContract === true) ? 'disabled' : false}>Apply New Settings on a 12 month contract</button>
                      Costs <b>$0 today</b> and then <b>${this.props.contractPrice}/{recurrenceLabel}</b> starting {moment(this.props.billingDate).format('DD MMMM YYYY')}
                    </div>
                  }
                </div>
              }
              {
                (this.props.hasActiveSignedContract && !this.props.arrears && !this.props.halt) &&
                <div className="col-md-6 col-xs-12 pb24">
                {
                  this.props.contractPrice < this.props.currentBillingAmount &&
                  <div>
                    <button className="btn apply-contract-btn btn-block btn-clear radius-6 mb10" style={{'whiteSpace': 'normal', 'minHeight': '65px'}} onClick={this.processContract} disabled={(this.props.processingContract === true) ? 'disabled' : false}>Apply new settings to your contract</button>
                    Costs <b>$0 today</b> and then <b>${this.props.currentBillingAmount}/{recurrenceLabel}</b> starting <strong>immediately</strong>
                  </div>
                }
                {
                  this.props.contractPrice > this.props.currentBillingAmount &&
                  <div>
                    <button className="btn apply-contract-btn btn-block btn-clear radius-6 mb10" style={{'whiteSpace': 'normal', 'minHeight': '65px'}} onClick={this.processContract} disabled={(this.props.processingContract === true) ? 'disabled' : false}>Apply new settings to your contract</button>
                    {
                      this.props.admin
                      ? this.renderEditableUpgradeCosts()
                      : <div>Costs <b>${this.props.additionalPaymentContractUpgrade} today</b> and then <b>${this.props.contractPrice}/{recurrenceLabel}</b> starting <strong>immediately</strong></div>
                    }
                  </div>
                }
                {
                  this.props.contractPrice === this.props.currentBillingAmount &&
                  <div>
                    <button className="btn apply-contract-btn btn-block btn-clear radius-6 mb10" style={{'whiteSpace': 'normal', 'minHeight': '65px'}} onClick={this.processContract} disabled={(this.props.processingContract === true) ? 'disabled' : false}>Apply new settings to your contract</button>
                    Costs <b>$0 today</b> and then <b>${this.props.contractPrice}/{recurrenceLabel}</b> starting <strong>immediately</strong>
                  </div>
                }
              </div>
              }
              {
                this.props.hasActiveSignedContract && this.props.arrears && !this.props.halt &&
                <div className="col-md-6 col-xs-12 pb24">
                <b>You currently have an outstanding payment on your account.</b> Please make a payment, and we will be able to provide you with a price for changing your contract.<br/><br/>
                  <a href="/products/" className="btn apply-contract-btn btn-block btn-clear radius-6 mb10">Update your payment information</a>
                </div>
              }
              {
                this.props.hasActiveSignedContract && !this.props.arrears && this.props.halt &&
                <div className="col-md-6 col-xs-12 pb24">
                <b>For more information on how to upgrade your contract please contact us on: 1800 934 184</b>
                </div>
              }
              <div className="col-xs-12">
                <a href="#!" onClick={this.cancelAllChanges}>Cancel settings changes</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PricingFooter
